<template>
  <b-form class="form" :class="size">
    <slot></slot>
  </b-form>
</template>

<script>
export default {
  name: 'FormContainer',
  props: {
    size: {
      type: String,
      default: 'medium'
    }
  }

}
</script>

<style scoped>
.form {
  margin-left: auto;
  margin-right: auto;
  margin-top: 15pt;
  padding: 10pt;
}

@media only screen and (min-width: 600px) {
  .form {
    margin-top: 30pt;
    padding: 30pt;

    border-radius: 10pt;
    border-color: white;
    border-width: 1pt;
    border-style: solid;
    background-color: rgba(255, 255, 255, 0.2);
  }
}

.form > * {
  margin-top: 20pt;
}

.form > *:first-child {
  margin-top: 0pt;
}

.small {
  max-width: 300pt;
}

.medium {
  max-width: 500pt;
}

.large {
  max-width: 900pt;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FormContainer.vue